//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { BodyText } from '@components/atoms/text/Text';
import { Product } from '@models/IItemMetadata';
import { ProductTagItem } from '@uia/products/product-tags/ProductTagItem';

export interface ProductTagsListProps {
  isDisabled: boolean;
  isCatalogConnected: boolean;
  onEditProductTag: (productTag: Product) => void;
  onRemoveProductTag: (productTag: Product) => void;
  productTags: Product[];
}

export const ProductTagsList = ({
  isCatalogConnected,
  isDisabled,
  onEditProductTag,
  onRemoveProductTag,
  productTags,
}: ProductTagsListProps) => (
  <ProductTags>
    <BodyText>Tagged Products</BodyText>
    {productTags.length === 0 && (
      <NoProducts>
        <BodyText>No products added</BodyText>
      </NoProducts>
    )}
    {productTags.map((productTag, index) => (
      <ProductTagItem
        key={`${productTag.id}-${index}`}
        isCatalogConnected={isCatalogConnected}
        isDisabled={isDisabled}
        onEditProductTag={onEditProductTag}
        onRemoveProductTag={onRemoveProductTag}
        productTag={productTag}
      />
    ))}
  </ProductTags>
);

const ProductTags = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: ${theme.spacings[2]};
  `,
);

const NoProducts = styled.div(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${theme.spacings[4]};
    border: ${theme.borderWidths[1]} solid ${theme.colors.gray1};
    border-radius: ${theme.borderRadii[2]};
    background-color: ${theme.colors.gray0};
  `,
);
